var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable max-statements */
import React, { useState, useEffect } from 'react';
import { uniq } from 'lodash';
import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../../../I18N";


import { InputField } from "../../../../Components/Forms/InputField";
import { defaultSearch, MultiselectList, RadioSelect } from "../../../../Components/Forms";
import { Modal, Button, Pill } from "../../../../Components/UI";
import { propertyIcons } from "../../../../Components/UI/Icons";
import {
  getAvailableSources,
  getPropertyNameFromExtractPair,
  getTemplateFromExtractPair } from "../helpers";


const SUPPORTED_PROPERTIES = [
'text',
'numeric',
'date',
'select',
'multiselect',
'relationship',
'markdown'];














const getPropertyLabel = (property, templateId) => {
  const { type } = property;

  const icon = propertyIcons[type];
  const propertyTypeTranslationKey = `property ${type}`;

  return (/*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "w-4" }, void 0, icon), /*#__PURE__*/
    _jsx(Translate, { context: templateId }, void 0, property.label), /*#__PURE__*/
    _jsx(Translate, {
      translationKey: propertyTypeTranslationKey,
      className: "lowercase before:content-['('] after:content-[')']" }, void 0,

    property.type
    )
    ));

};

const formatOptions = (values, templates) => {
  const propertyName = values.length ? getPropertyNameFromExtractPair(values[0]) : null;
  return templates.
  map((template) => {var _template$properties;
    const option = {
      label: template.name,
      id: template._id,
      searchLabel: template.name,
      value: template._id,
      items: (_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.
      filter(
        (prop) =>
        (!propertyName || prop.name === propertyName) &&
        SUPPORTED_PROPERTIES.includes(prop.type)
      ).
      map((prop) => {var _template$_id;return {
          label: getPropertyLabel(prop, template._id),
          value: `${(_template$_id = template._id) === null || _template$_id === void 0 ? void 0 : _template$_id.toString()}-${prop.name}`,
          searchLabel: prop.label
        };})
    };

    if (propertyName === 'title' || !propertyName) {var _template$_id2;
      option.items.push({
        label: getPropertyLabel({ label: 'Title', name: 'Title', type: 'text' }, template._id),
        value: `${(_template$_id2 = template._id) === null || _template$_id2 === void 0 ? void 0 : _template$_id2.toString()}-title`,
        searchLabel: 'Title'
      });
    }

    return option;
  }).
  filter((template) => template.items.length);
};

const getPropertyForValue = (value, templates) => {
  const [templateId, propertyName] = (value || '').split('-');

  const matchedTemplate = templates.find((template) => template._id.toString() === templateId);

  if (propertyName === 'title') {
    return getPropertyLabel(
      {
        name: 'title',
        label: 'Title',
        type: 'text'
      },
      matchedTemplate._id.toString()
    );
  }

  const matchedProperty = matchedTemplate === null || matchedTemplate === void 0 ? void 0 : matchedTemplate.properties.find(
    (property) => property.name === propertyName
  );

  if (matchedProperty) {
    return getPropertyLabel(matchedProperty, matchedTemplate._id.toString());
  }

  return /*#__PURE__*/_jsx("div", {});
};

const ExtractorModal = ({
  setShowModal,
  onClose,
  onAccept,
  templates,
  extractor
}) => {
  const initialValues =
  (extractor === null || extractor === void 0 ? void 0 : extractor.templates.map((template) => `${template}-${extractor.property}`)) || [];

  const [step, setStep] = useState(1);
  const [name, setName] = useState((extractor === null || extractor === void 0 ? void 0 : extractor.name) || '');
  const [values, setValues] = useState(initialValues);
  const [source, setSource] = useState('0');
  const [options, setOptions] = useState([]);
  const [hasNameError, setNameError] = useState(false);

  const handleClose = () => {
    setName('');
    setValues([]);
    onClose();
  };

  useEffect(() => {
    setOptions(formatOptions(values, templates));
  }, [values, templates]);

  const handleSubmit = () => {
    if (!name.length) {
      setNameError(true);
      return;
    }

    const extractorSource = source === '0' ? { pdf: true } : { property: source };

    const result = values.length ?
    {
      name,
      source: extractorSource,
      property: getPropertyNameFromExtractPair(values[0]),
      templates: uniq(values.map((value) => getTemplateFromExtractPair(value)))
    } :
    null;

    if (result && extractor) {
      result._id = extractor._id;
    }

    if (result === null) {
      handleClose();
    } else {
      onAccept(result);
      handleClose();
    }
  };

  const onSearch = (search) => {
    const newItems = defaultSearch(search, formatOptions(values, templates));
    setOptions(newItems);
  };

  return (/*#__PURE__*/
    _jsx(Modal, { size: "xxl" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h1", { className: "text-xl font-medium text-gray-900" }, void 0,
    extractor ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Edit Extractor") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Add Extractor")
    ), /*#__PURE__*/
    _jsx(Modal.CloseButton, { onClick: () => setShowModal(false) })
    ), /*#__PURE__*/

    _jsx(Modal.Body, { className: "pt-0" }, void 0, /*#__PURE__*/
    _jsx(InputField, {
      className: "mt-6",
      id: "extractor-name",
      placeholder: "Extractor name",
      hasErrors: hasNameError,
      value: name,
      onChange: (event) => {
        setName(event.target.value);
        setNameError(false);
      } }
    ), /*#__PURE__*/

    _jsx("div", { className: `${step !== 1 ? 'hidden' : ''} pt-2 h-96` }, void 0, /*#__PURE__*/
    _jsx(MultiselectList, {
      selectedValues: values || [],
      items: options,
      onChange: setValues,
      onSearch: onSearch,
      checkboxes: true,
      foldableGroups: true,
      allowSelelectAll: values.length > 0,
      startOnSelected: values.length > 0 }
    )
    ), /*#__PURE__*/
    _jsx("div", { className: `${step !== 2 && 'hidden'} mt-6` }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("h6", { className: "text-sm font-medium" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Input")
    ), /*#__PURE__*/
    _jsx("div", { className: "p-3" }, void 0, getPropertyForValue(values[0], templates)), /*#__PURE__*/
    _jsx("h6", { className: "text-sm font-medium" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected templates")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex flex-wrap p-3" }, void 0,
    values.map((value) => {
      const templateId = getTemplateFromExtractPair(value);
      const template = templates.find((temp) => temp._id === templateId);
      return (/*#__PURE__*/
        _jsx(Pill, { color: "gray", className: "m-1" }, templateId,
        template === null || template === void 0 ? void 0 : template.name
        ));

    })
    ), /*#__PURE__*/
    _jsx("h6", { className: "text-sm font-medium" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Common sources")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex flex-wrap p-3" }, void 0, /*#__PURE__*/
    _jsx(RadioSelect, {
      name: "pdf",
      options: getAvailableSources(templates, values, extractor),
      onChange: (selected) => {
        setSource(selected.currentTarget.value);
      } }
    )
    )
    )
    ), /*#__PURE__*/

    _jsx("div", { className: "flex justify-center w-full gap-2" }, void 0, /*#__PURE__*/
    _jsx("div", { className: `w-2 h-2 rounded-full ${step === 1 ? 'bg-indigo-700' : 'bg-gray-200'}` }), /*#__PURE__*/
    _jsx("div", { className: `w-2 h-2 rounded-full ${step === 2 ? 'bg-indigo-700' : 'bg-gray-200'}` })
    )
    ), /*#__PURE__*/

    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0,
    step === 1 ? /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: () => setShowModal(false), className: "grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", onClick: () => setStep(2), disabled: values.length === 0 }, void 0, /*#__PURE__*/
    _jsx("span", { className: "flex items-center justify-center gap-2 flex-nowrap" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Next"), /*#__PURE__*/
    _jsx(ArrowRightIcon, { className: "w-5" })
    )
    )
    ) : /*#__PURE__*/

    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: () => setStep(1), className: "grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Back")
    ), /*#__PURE__*/
    _jsx(Button, { className: "grow", onClick: () => handleSubmit(), color: "success" }, void 0,
    extractor ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Update") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Create")
    )
    )

    )
    )
    )
    ));

};

export { ExtractorModal, formatOptions };